var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMinorCategory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 14,
    viewBox: "0 0 10 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.73628 9.3516L4.78686 13.3169C4.88467 13.4347 5.0594 13.4508 5.17713 13.3531C5.19023 13.3422 5.20235 13.3301 5.21324 13.3169L9.26382 9.3516C9.39334 9.23155 9.40101 9.02919 9.28096 8.89968C9.22143 8.83545 9.13818 8.79844 9.05061 8.7973L7.13193 8.79729L7.13193 3.65944C7.09553 3.44472 6.92186 3.27975 6.70555 3.25437L3.29451 3.25437C3.12395 3.25436 3.08135 3.46753 3.08135 3.65944L3.08134 8.79729L0.949449 8.79729C0.772842 8.79962 0.631572 8.94464 0.633898 9.12125C0.63504 9.20882 0.672052 9.29206 0.73628 9.3516Z",
    fill: "#187B96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M3.29456 2.61523L6.7056 2.61523C6.8822 2.61523 7.02539 2.47205 7.02539 2.29544C7.02539 2.11883 6.8822 1.97565 6.7056 1.97565L3.29456 1.97564C3.11796 1.97564 2.97477 2.11883 2.97477 2.29544C2.97477 2.47205 3.11791 2.61523 3.29456 2.61523Z",
    fill: "#187B96"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M3.29456 1.33594L6.7056 1.33594C6.8822 1.33594 7.02539 1.19275 7.02539 1.01614C7.02539 0.839536 6.8822 0.696348 6.7056 0.696348L3.29456 0.696348C3.11796 0.696348 2.97477 0.839535 2.97477 1.01614C2.97477 1.19275 3.11791 1.33594 3.29456 1.33594Z",
    fill: "#187B96"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinorCategory);
export default __webpack_public_path__ + "static/media/minorCategory.af5a8200847a6f9df9d4d3f718b3fbe5.svg";
export { ForwardRef as ReactComponent };